import React, { useContext, useState } from 'react';
import { Box, Stack, Button } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate, useLocation } from 'react-router-dom';
import { OnboardingLayout } from './onboard-layout';
import StoreContext from '../../../react-core-lib/components/app/store-context';
import ApiButton from '../../UIControls/api-button/api-button';
import UserApi from '../../../rest-api/user-api';
import VerificationCodeInput from './verification-code-input';
import ResendVerificationLink from './resend-verification-link';
import mixpanel from 'mixpanel-browser';
import KlaviyoApi from '../../../rest-api/klaviyo-api';
import { useSnackbar } from '../../authenticated/SnackbarProvider';
import PaymentApi from '../../../rest-api/payment-api';
import subscriptionPlans from '../../authenticated/settings/subscriptionPlans';

const OnboardVerificationCodeScreen = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [userData, setUserData] = useState(() => {
        const storedUserData = JSON.parse(localStorage.getItem('userData') || '{}');
        return { ...storedUserData, ...location.state?.userData };
    });
    const appStateStore = useContext(StoreContext);
    const { authStore, userDataStore } = useContext(StoreContext);
    const [otp, setOtp] = useState('');
    const [otpComplete, setOtpComplete] = React.useState(false);
    const showSnackbar = useSnackbar();
    const searchParams = new URLSearchParams(location.search);
    const inviteId = searchParams.get('inviteId');
    const senderId = searchParams.get('senderId');

    const isShowOffer = searchParams.get('LVS');
    console.log('/code local storage ', JSON.parse(localStorage.getItem('userData')));
    console.log('isShowOffer? ', isShowOffer);
    console.log('/code location state', location.state?.userData);

    const handleBack = () => {
        navigate('/onboard/password', { state: { userData } });
    };

    const verifyCode = async (otp) => {
        const codeAsString = String(otp);
        // console.log(
        //     `verifyCode called email: ${userData.emailAddress}, otp as string: ${codeAsString}`,
        //     userData,
        //     inviteId,
        // );
        const result = await authStore.confirmRegistration(
            userData.emailAddress,
            userData.password,
            codeAsString,
            onRegistrationConfirmed,
        );

        if (result.success) {
        } else {
            console.error('Error during authentication:', result.message);
            throw new Error(result.message);
        }
    };

    // callback function referenced as asyncAppInitializer in auth store
    const onRegistrationConfirmed = async (userId, idToken) => {
        console.warn(`onRegistrationConfirmed called: userId: ${userId}, idToken: ${idToken}`);
        let payload = userData;
        payload.clinicImageId = '';
        payload.showLogoInHandouts = true;
        payload.handouts = [];
        delete payload.password;

        await appStateStore.initializeUserStores(userId);

        // Check the 'LVS' parameter in the query string and store it if true
        if (isShowOffer) {
            localStorage.setItem('LVS', 'true');
        }

        console.log('onRegistrationConfirmed payload to send:', payload);

        try {
            if (inviteId) {
                userData.inviteId = inviteId;
                userData.action = 'acceptInvitation';
                await UserApi.updateClinicianDataMultiuser(idToken, userData);
                var inviteUserData = await UserApi.getClinicianData(idToken);
            } else {
                if (payload?.subscriptionData?.accountType === 'Free') {
                    try {
                        const freePlan = subscriptionPlans.Free;
                        const planDetails = {
                            priceId: freePlan.priceMonthlyId,
                            productId: freePlan.productId,
                            isMonthly: true,
                            accountType: freePlan.accountType,
                        };

                        const paymentResponse = await PaymentApi.updatePaymentDetails(idToken, {
                            userId,
                            email: payload.emailAddress,
                            plan: planDetails,
                        });
                        console.log('Free plan Stripe response (physio):', paymentResponse);
                        mixpanel.identify(payload.emailAddress);
                        mixpanel.track('FreePlanCreated', {
                            userId,
                            email: payload.emailAddress,
                        });

                        payload.subscriptionData = {
                            ...payload.subscriptionData,
                            stripeCustomerId: paymentResponse?.customerId || null,
                            subscriptionId: paymentResponse?.subscription?.id || null,
                            subscriptionEndDate: paymentResponse?.subscription?.current_period_end
                                ? paymentResponse.subscription.current_period_end * 1000
                                : null,
                            pendingPlan: null,
                        };
                    } catch (err) {
                        console.error('Error provisioning Free plan in Stripe:', err);
                    }
                }

                const res = await UserApi.updateClinicianData(idToken, payload);
            }

            if (appStateStore) {
                console.warn('attempting to store: ', payload, appStateStore, inviteUserData);
                const { userDataStore } = appStateStore;
                if (inviteUserData) {
                    let inviteUserIntegrations = null;
                    if (inviteUserData.multiuserData?.multiuserUsers) {
                        const foundUser = inviteUserData.multiuserData.multiuserUsers.find(
                            (user) => user.userId === userId,
                        );
                        inviteUserIntegrations = foundUser?.integrations || null;
                    }
                    let formattedData = {
                        firstName: inviteUserData.userData.firstName,
                        lastName: inviteUserData.userData.lastName,
                        emailAddress: inviteUserData.userData.emailAddress,
                        mobile: inviteUserData.userData.mobile || '',
                        clinicName: inviteUserData.clinicData.clinicName,
                        clinicNumber: inviteUserData.clinicData.clinicNumber || '',
                        clinicSize: inviteUserData.clinicData.clinicSize || '',
                        clinicImageId: '',
                        showLogoInHandouts: inviteUserData.showLogoInHandouts,
                        handouts: JSON.stringify(inviteUserData.handouts),
                        subscriptionData: {
                            ...inviteUserData.subscriptionData,
                            accountType: 'Clinic-multiuser',
                        },
                        inviteId: inviteId,
                        integrations: inviteUserIntegrations,
                    };
                    userDataStore.setUserData(formattedData);
                } else {
                    payload.handouts = '[]';
                    userDataStore.setUserData(payload);
                }
            } else {
                console.error('userDataStore is not defined.');
            }

            await mixpanel.identify(userData.emailAddress);

            // Capture UTM parameters from localStorage (stored on initial page load)
            const storedUtmParams = localStorage.getItem('utmParams');
            const utmParams = storedUtmParams ? JSON.parse(storedUtmParams) : {};

            const mixpanelTrackData = {
                userId: userId,
                email: userData.emailAddress,
                ...(userData.clinicNumber && { clinicNumber: userData.clinicNumber }),
                ...(userData.clinicName && { clinicName: userData.clinicName }),
                ...(userData.mobile && { mobile: userData.mobile }),
                ...(userData.clinicSize && { clinicSize: userData.clinicSize }),
                userName: userData.firstName + ' ' + userData.lastName,
                // UTM tracking
                ...(utmParams.utm_source && { utmSource: utmParams.utm_source }),
                ...(utmParams.utm_medium && { utmMedium: utmParams.utm_medium }),
                ...(utmParams.utm_campaign && { utmCampaign: utmParams.utm_campaign }),
                ...(utmParams.utm_term && { utmTerm: utmParams.utm_term }),
                ...(utmParams.utm_content && { utmContent: utmParams.utm_content }),
            };

            await mixpanel.track('New User Sign Up', mixpanelTrackData);

            const mixpanelPeopleData = {
                $first_name: userData.firstName,
                $last_name: userData.lastName,
                $email: userData.emailAddress,
                ...(userData.mobile && { Mobile: userData.mobile }),
                ...(userData.clinicName && { 'Clinic Name': userData.clinicName }),
                ...(userData.clinicNumber && { 'Clinic Number': userData.clinicNumber }),
                ...(userData.clinicSize && { 'Clinic Size': userData.clinicSize }),
                // UTM tracking on profile
                ...(utmParams.utm_source && { 'Initial UTM Source': utmParams.utm_source }),
                ...(utmParams.utm_medium && { 'Initial UTM Medium': utmParams.utm_medium }),
                ...(utmParams.utm_campaign && { 'Initial UTM Campaign': utmParams.utm_campaign }),
            };

            await mixpanel.people.set(mixpanelPeopleData);

            // Clear UTM params after signup
            localStorage.removeItem('utmParams');

            // Track user description selections as tags
            if (userData.userDescription && userData.userDescription.length > 0) {
                const userDescriptionTagMap = {
                    'Practice Manager / Owner': 'Practice Manager - Owner',
                    Lecturer: 'Lecturer',
                    Receptionist: 'Receptionist',
                    Student: 'Student',
                    Other: 'Other',
                };

                const tags = userData.userDescription.map((desc) => userDescriptionTagMap[desc] || desc);

                // Set people properties with individual boolean flags for segmentation
                const peopleProperties = {
                    'User Description': tags, // Keep array for reference
                    'User Description Text': tags.join(', '), // Readable string
                };

                // Add individual boolean properties for each tag for easy filtering
                tags.forEach((tag) => {
                    peopleProperties[tag] = true;
                });

                await mixpanel.people.set(peopleProperties);

                // Track event with individual boolean properties for segmentation
                const eventProperties = {
                    userId: userId,
                    email: userData.emailAddress,
                    descriptions: tags,
                    descriptionsText: tags.join(', '),
                };

                // Add individual boolean properties to event for filtering
                tags.forEach((tag) => {
                    eventProperties[tag] = true;
                });

                await mixpanel.track('User Description Selected', eventProperties);
            }

            await KlaviyoApi.updateUserInKlaviyo(idToken, payload.emailAddress, 'General');

            if (payload?.subscriptionData?.accountType === 'Free') {
                await KlaviyoApi.updateUserInKlaviyo(idToken, payload.emailAddress, 'Free', {
                    preserveExistingLists: true,
                });
            }
            localStorage.removeItem('userData');
        } catch (error) {
            console.error('Error during post-registration onboard/code onRegistrationConfirmed:', error);
        }
    };

    const ResendLink = () => <ResendVerificationLink authStore={authStore} emailAddress={userData.emailAddress} />;

    const renderButtonGroup = () => (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: 'auto',
                padding: '24px 0',
            }}
        >
            <Box onClick={handleBack} sx={{ display: 'flex', alignItems: 'center', width: 120 }}>
                <KeyboardBackspaceIcon />
                <Button
                    sx={{
                        color: '#000453',
                        textDecoration: 'underline',
                        textTransform: 'none',
                        fontWeight: 600,
                    }}
                >
                    Go back
                </Button>
            </Box>

            {renderNextButton()}
        </Box>
    );

    const renderNextButton = () => (
        <ApiButton
            apiCall={() => verifyCode(otp)}
            buttonLabel="Next"
            color="primary"
            errorTitle="Signup error"
            errorMessage="There was a problem with the signup. Please try again."
            successTitle="Save Successful"
            successMessage="Your changes were saved successfully."
            disabled={!otpComplete}
            fullWidth={true}
            buttonVariant="pink"
            sx={{ maxWidth: 200, m: 0, borderRadius: 36 }}
        />
    );

    const renderInputChildren = () => (
        <Box position={'relative'}>
            <Stack spacing={0} alignItems="center" justifyContent="center">
                <VerificationCodeInput setOtpComplete={setOtpComplete} onOtpChange={(value) => setOtp(value)} />
            </Stack>
            <ResendLink />
        </Box>
    );

    const { accountType } = userData.subscriptionData || {};
    // Free and Student plans skip practice details, so verification is step 3 instead of 4
    const currentStepNumber = accountType === 'Student' || accountType === 'Free' ? 3 : 4;

    return (
        <OnboardingLayout
            title="OTP Verification"
            subtitle="Enter the verification code we just sent to your email address"
            inputChildren={renderInputChildren()}
            navChildren={renderButtonGroup()}
            currentStep={currentStepNumber}
            previousStepPath="/onboard/password"
            userData={userData}
        />
    );
};

export default OnboardVerificationCodeScreen;
